import { observer } from 'mobx-react';
import Link from 'next/link';
import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export interface Props {
  title: React.ReactNode;
  href: string;
  icon?: string;
}

@observer
export class PortalAsideLink extends React.Component<Props, {}> {
  static contextType = StoreContext;
  declare context: Store;

  get liClassName() {
    const { pathurl } = this.context.requestStore.requestLocation;
    const { href } = this.props;
    if (pathurl === href) {
      return 'menu-item menu-item-active';
    }
    return 'menu-item';
  }

  render() {
    const { title, href, icon } = this.props;

    return (
      <li className={this.liClassName} aria-haspopup="true">
        <Link href={href}>
          <a className="menu-link">
            <i className={`menu-icon ${icon}`} />
            <span className="menu-text">{title}</span>
          </a>
        </Link>
      </li>
    );
  }
}
